import React, { useRef } from 'react';
import { Select } from 'antd';
import { BaseSelectRef } from 'rc-select';
import { AWSRegionTypeMap } from '../../models/awsRegion';

const { Option } = Select;

interface AWSRegionSelectProps {
    onSelect?: (value: string) => void;
    value?: string;
    onChange?: (value: string) => void;
}

const AWSRegionSelect: React.FC<AWSRegionSelectProps> = props => {
    const { onSelect, value, onChange } = props;
    const selectEl = useRef<BaseSelectRef>(null);

    const onAWSRegionSelect = (e: string) => {
        selectEl.current!.blur();
        if (onSelect) {
            onSelect(e);
        }
    };

    const renderOption = (item: [string, string]) => (
        <Option
            key={item[0]}
            value={item[0]}
        >
            {item[1]}
        </Option>
    );

    return (
        <Select
            value={value}
            defaultValue={undefined}
            ref={selectEl}
            optionFilterProp="children"
            placeholder="Select region"
            onSelect={onAWSRegionSelect}
            onChange={onChange}
            allowClear
        >
            {[...Object.entries(AWSRegionTypeMap)].map(renderOption)}
        </Select>
    );
};

export default AWSRegionSelect;
